import React from "react";
import Header from "Components/Header";
import HeaderMobile from "Components/HeaderMobile";
import Footer from "Components/Footer";
import FooterMobile from "Components/FooterMobile";

import {
  BrowserRouter as Router,
  Route,
  Redirect,
  Switch
} from "react-router-dom";
import Home from "Routes/Home";
import Counsel from "Routes/Counsel";
import Diagnosis from "Routes/Diagnosis";
import Introduction from "Routes/Introduction";
import Reservation from "Routes/Reservation";

import HomeMobile from "RoutesMobile/Home";
import CounselMobile from "RoutesMobile/Counsel";
import DiagnosisMobile from "RoutesMobile/Diagnosis";
import IntroductionMobile from "RoutesMobile/Introduction";
import ReservationMobile from "RoutesMobile/Reservation";

export default class extends React.Component {
  state = {
    width: window.innerWidth
  };

  componentWillMount() {
    window.addEventListener("resize", this.handleWindowSizeChange);
  }

  // make sure to remove the listener
  // when the component is not mounted anymore
  componentWillUnmount() {
    window.removeEventListener("resize", this.handleWindowSizeChange);
  }

  handleWindowSizeChange = () => {
    this.setState({ width: window.innerWidth });
  };

  render() {
    const { width } = this.state;
    const isMobile = width <= 768;

    if (isMobile) {
      return (
        <>
          <Router>
            <HeaderMobile />
            <Switch>
              <Route path="/" exact component={HomeMobile} />
              <Route path="/counsel" component={CounselMobile} />
              <Route path="/diagnosis" component={DiagnosisMobile} />
              <Route path="/introduction" component={IntroductionMobile} />
              <Route path="/reservation" component={ReservationMobile} />
              <Redirect from="*" to="/" />
            </Switch>
          </Router>
          <FooterMobile />
        </>
      );
    } else {
      return (
        <>
          <Router>
            <Header />
            <Switch>
              <Route path="/" exact component={Home} />
              <Route path="/counsel" component={Counsel} />
              <Route path="/diagnosis" component={Diagnosis} />
              <Route path="/introduction" component={Introduction} />
              <Route path="/reservation" component={Reservation} />
              <Redirect from="*" to="/" />
            </Switch>
          </Router>
          <Footer />
        </>
      );
    }
  }
}
